import { render, staticRenderFns } from "./PersonReport.vue?vue&type=template&id=b915e182&"
import script from "./PersonReport.vue?vue&type=script&lang=js&"
export * from "./PersonReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonReport.vue"
export default component.exports